import PositionDto from '@/models/Positions/PositionDto';
import SkillDto from '@/models/Skills/SkillDto';
import QualificationDto from '@/models/Qualifications/QualificationDto';

export default class AgencyAttributesDto {
	positions: PositionDto[] = [];
    skills: SkillDto[] = [];
    qualifications: QualificationDto[] = [];		
}